import {get} from "lodash"
import BaseService from "./Base"
import {ListSapCheckpointsPayload, SapCheckpoint, SapCheckpointPayload} from "types/settings/sap-checkpoint"
import {ListSapCheckpointChecksPayload, SapCheckpointCheck} from "types/settings/sap-checkpoint-check"

class SapCheckpointsService extends BaseService {
    async list(params: ListSapCheckpointsPayload = {}): Promise<{data: SapCheckpoint[]; total: number}> {
        const response = await this.post("/v1/sap-checkpoints/list", params)
        const result = get(response, "data", {})
        return {
            data: get(result, "data", []),
            total: get(result, "total", 0)
        }
    }

    async getOne(sapCheckpointId: number): Promise<SapCheckpoint> {
        const response = await this.post("/v1/sap-checkpoints/get", {sapCheckpointId})
        return get(response, "data.data", {})
    }

    async create(data: SapCheckpointPayload): Promise<SapCheckpoint> {
        const response = await this.post("/v1/sap-checkpoints/create", data)
        return get(response, "data.data", {})
    }

    async update(sapCheckpointId: number, data: SapCheckpointPayload): Promise<SapCheckpoint> {
        const response = await this.post("/v1/sap-checkpoints/update", {sapCheckpointId, ...data})
        return get(response, "data.data", {})
    }

    async deleteBulk(sapCheckpointIds: number[]): Promise<void> {
        await this.post("/v1/sap-checkpoints/delete", {sapCheckpointIds})
    }

    async listChecks(
        params: ListSapCheckpointChecksPayload = {}
    ): Promise<{data: SapCheckpointCheck[]; total: number}> {
        const response = await this.post("/v1/sap-checkpoint-checks/list", params)
        const result = get(response, "data", {})
        return {
            data: get(result, "data", []),
            total: get(result, "total", 0)
        }
    }

    async rerunCheck(sapCheckpointCheckId: number): Promise<SapCheckpointCheck> {
        const response = await this.post("/v1/sap-checkpoint-checks/rerun", {sapCheckpointCheckId})
        return get(response, "data.data", {})
    }
}

export default SapCheckpointsService
